import React from 'react';
import { CHART_TYPE, GOAL_KEY, LEGEND_BY_CHANNEL } from '../../../../constants/trend_report';
import { CustomizedDot, getMaximallyDifferentRandomColor } from '../../../../utils/graph-utils';
import { Bar, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip, Line, ComposedChart } from '../../../../recharts';
import { extractColumnKey } from '../../utils/composite_keys';

export class TrendReportChart extends React.Component {
  constructor(props) {
    super(props);
    this.goalLineColor = 0;
  }

  getLegendType = (key) => {
    let originalKey = extractColumnKey(key);
    let channel = originalKey.split('-')[0].toUpperCase();
    return LEGEND_BY_CHANNEL[channel] ? LEGEND_BY_CHANNEL[channel] : LEGEND_BY_CHANNEL['default'];
  };

  getYAxis = (bothAccuracyAndVarianceSelected, allLinesId) => {
    let labelValue = () => {
      if (bothAccuracyAndVarianceSelected) {
        return '%';
      } else {
        if (allLinesId.length === 0) {
          return '';
        } else {
          return allLinesId[0].includes('Accuracy') ? '%' : '$';
        }
      }
    };
    let yAxis = [];
    yAxis.push(
      <YAxis
        yAxisId="left"
        label={{ value: labelValue(), position: 'insideTopLeft' }}
        type="number"
        domain={['auto', labelValue() === '%' ? 100 : 'auto']}
        key={1}
      />
    );
    if (bothAccuracyAndVarianceSelected) {
      yAxis.push(
        <YAxis
          yAxisId="right"
          orientation="right"
          label={{ value: '$', position: 'insideTopRight' }}
          type="number"
          domain={['auto', 'auto']}
          key={2}
        />
      );
    }
    return yAxis;
  };

  getLines = (allLinesId, bothAccuracyAndVarianceSelected, labelFormatter) => {
    let lines = [];
    let colorIndex = 0;
    allLinesId.forEach((id) => {
      const yAxisPos = bothAccuracyAndVarianceSelected && !id.includes(GOAL_KEY) && !id.includes('Accuracy') ? 'right' : 'left';
      const strokeDash = id.includes(GOAL_KEY) ? '5 5' : '';
      this.goalLineColor = id.includes(GOAL_KEY) ? this.goalLineColor : getMaximallyDifferentRandomColor(colorIndex++, allLinesId.length);
      lines.push(
        <Line
          yAxisId={yAxisPos}
          name={labelFormatter(id)}
          strokeWidth="2"
          key={id}
          dataKey={id}
          stroke={this.goalLineColor}
          strokeDasharray={strokeDash}
          dot={<CustomizedDot />}
          legendType={this.getLegendType(id)}
        />
      );
    });
    return lines;
  };

  getBars = (allLinesId, bothAccuracyAndVarianceSelected, labelFormatter) => {
    let bars = [];
    let colorIndex = 0;
    allLinesId.forEach((id) => {
      const yAxisPos = bothAccuracyAndVarianceSelected && !id.includes(GOAL_KEY) && !id.includes('Accuracy') ? 'right' : 'left';
      this.goalLineColor = id.includes(GOAL_KEY) ? this.goalLineColor : getMaximallyDifferentRandomColor(colorIndex++, allLinesId.length);
      if (id.includes(GOAL_KEY)) {
        bars.push(
          <Line
            yAxisId={yAxisPos}
            name={labelFormatter(id)}
            strokeWidth="2"
            key={id}
            dataKey={id}
            stroke={this.goalLineColor}
            strokeDasharray="5 5"
            legendType={this.getLegendType(id)}
          />
        );
      } else {
        bars.push(
          <Bar
            yAxisId={yAxisPos}
            name={labelFormatter(id)}
            key={id}
            dataKey={id}
            fill={this.goalLineColor}
            legendType="square"
          />
        );
      }
    });
    return bars;
  };

  getPlot = (chartType, data, bothAccuracyAndVarianceSelected, allLinesId, labelFormatter) => {
    if (chartType === CHART_TYPE.BAR) {
      return this.getBars(allLinesId, bothAccuracyAndVarianceSelected, labelFormatter);
    } else {
      return this.getLines(allLinesId, bothAccuracyAndVarianceSelected, labelFormatter);
    }
  };

  render() {
    return (
      <div style={{ width: '99%', padding: '0' }}>
        <ResponsiveContainer aspect={3}>
          <ComposedChart data={this.props.data} margin={{ top: 10, right: 30, left: 20, bottom: 10 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="formattedMonth" />
            {this.getYAxis(this.props.bothAccuracyAndVarianceSelected, this.props.allLinesId)}
            <Tooltip />
            <Legend />
            {this.getPlot(
              this.props.chartType,
              this.props.data,
              this.props.bothAccuracyAndVarianceSelected,
              this.props.allLinesId,
              this.props.labelFormatter
            )}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/trend/trend_report_chart.js